import { resolveLocalePath } from '@vuepress/shared';
import { inject } from 'vue';
/**
 * Injection key for page route locale path
 */
export const routeLocaleSymbol = Symbol(__VUEPRESS_DEV__ ? 'routeLocale' : '');
/**
 * Returns the ref of the route locale path of current page
 */
export const useRouteLocale = () => {
    const routeLocale = inject(routeLocaleSymbol);
    if (!routeLocale) {
        throw new Error('useRouteLocale() is called without provider.');
    }
    return routeLocale;
};
/**
 * Resolve locale path according to route path and locales config
 */
export const resolveRouteLocale = (locales, routePath) => resolveLocalePath(locales, routePath);
